
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Venue } from '@/interfaces/models/Venue';
import { EnrollmentStatus } from '@/enums/EnrollmentStatus';
import { RolloutStatus } from '@/enums/RolloutStatus';

interface Selection {
  venues?: string[];
  enrollmentStatus?: string;
  rolloutStatus?: string;
  reviewerId?: string;
}

@Component
export default class EnrollmentsFilter extends Vue {
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public selectedVenues: string[] = [];
  public selectedEnrollmentStatus: string = '';
  public selectedRolloutStatus: string = '';
  public selectedReviewerId: string = '';

  private timer: any = null;

  get selection(): Selection {
    const selection: Selection = {};

    if (this.selectedVenues?.length) {
      selection.venues = this.selectedVenues;
    }

    if (this.selectedEnrollmentStatus) {
      selection.enrollmentStatus = this.selectedEnrollmentStatus;
    }

    if (this.selectedRolloutStatus) {
      selection.rolloutStatus = this.selectedRolloutStatus;
    }

    if (this.selectedReviewerId) {
      selection.reviewerId = this.selectedReviewerId;
    }

    return selection;
  }

  get enrollmentStatuses(): string[] {
    return Object.values(EnrollmentStatus);
  }

  get rolloutStatuses(): string[] {
    return Object.values(RolloutStatus);
  }

  public debouncedSearch() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    const self = this;

    this.timer = setTimeout(() => {
      self.$emit('filter', self.selection);
    }, 500);
  }

  @Watch('selection')
  public onFilterChange() {
    this.debouncedSearch();
  }
}
